export enum FlyOutListingUserType {
  'NEW' = 'NEW',
  'MIGRATED' = 'MIGRATED',
  'MANAGED' = 'MANAGED',
}
